export class GLSModel {
    producto: string;
    numeroSerie: number;
    imei: string;
    sim: string;

    constructor() { }
}
